module.exports = __webpack_public_path__ + "c4f96d274b15734bf4453bbb66721010.jpg";